import { render } from "./VideoPlay.vue?vue&type=template&id=e12bff16&scoped=true&ts=true"
import script from "./videoPlayHelper.ts?vue&type=script&lang=ts"
export * from "./videoPlayHelper.ts?vue&type=script&lang=ts"

import "./VideoPlay.vue?vue&type=style&index=0&id=e12bff16&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12bff16"]])

export default __exports__